import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';

const LEFT_BOLT_PATH =
  'M5.12734 7.4246H6.87044C6.97552 7.4246 7.03674 7.54208 6.97583 7.62686L3.155 12.9455C3.07116 13.0622 2.88652 12.9754 2.92492 12.8373L3.95726 9.12461H2.12943C2.04057 9.12461 1.97818 9.03792 2.00719 8.95476L3.35689 5.08624C3.37489 5.03463 3.42398 5 3.47913 5H6.23784C6.33587 5 6.39826 5.10376 6.35154 5.18907L5.12734 7.4246Z';
const RIGHT_BOLT_PATH =
  'M13.1273 7.4246H14.8704C14.9755 7.4246 15.0367 7.54208 14.9758 7.62686L11.155 12.9455C11.0712 13.0622 10.8865 12.9754 10.9249 12.8373L11.9573 9.12461H10.1294C10.0406 9.12461 9.97818 9.03792 10.0072 8.95476L11.3569 5.08624C11.3749 5.03463 11.424 5 11.4791 5H14.2378C14.3359 5 14.3983 5.10376 14.3515 5.18907L13.1273 7.4246Z';
const CENTER_BOLT_PATH =
  'M9.37827 6.6369H11.8186C11.9657 6.6369 12.0514 6.81312 11.9662 6.94028L6.617 14.9182C6.49962 15.0933 6.24113 14.963 6.29488 14.7559L7.74016 9.18692H5.18121C5.0568 9.18692 4.96945 9.05688 5.01007 8.93214L6.89964 3.12936C6.92485 3.05194 6.99357 3 7.07078 3H10.933C11.0702 3 11.1576 3.15564 11.0922 3.28361L9.37827 6.6369Z';

type LightningTotalIconProps = SvgIconProps & {
  /** Background behind the icon, for the center bolt's outline */
  outlineColor?: string;
};

export const LightningTotalIcon = ({
  outlineColor,
  ...props
}: LightningTotalIconProps): JSX.Element => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <path d={LEFT_BOLT_PATH} fill="currentColor" fillOpacity={0.7} />
      <path d={RIGHT_BOLT_PATH} fill="currentColor" fillOpacity={0.7} />
      <path
        d={CENTER_BOLT_PATH}
        fill={theme.palette.brand[500]}
        stroke={outlineColor ?? theme.palette.background.default}
        paintOrder="stroke"
      />
    </SvgIcon>
  );
};
